import React from 'react';
import ReactDOM from 'react-dom';

import CloseInfo from './components/pages/CloseInfo/CloseInfo';

import './index.less';

ReactDOM.render(
  (
    <CloseInfo />
  ), document.getElementById('root'),
);



// WEBPACK FOOTER //
// ./src/index.js